module.exports = __webpack_public_path__ + "img/基站.83b4e71a.svg";